import { Reveal } from "@/components/motion";
import { SectionHeading } from "@/components/primitives";
import Icon from "@/components/Icon";
import { INTEGRATIONS } from "@/lib/site";

export default function IntegrationsSection() {
  return (
    <section id="integrations" className="relative border-t border-border py-24 sm:py-32" data-testid="integrations-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="Integrations"
          title="Connect the tools you already use."
          subtitle="Workspace is the hub — not another silo. Integrations arrive as the platform grows."
        />

        <Reveal className="mt-16 grid grid-cols-2 gap-px overflow-hidden rounded-3xl border border-border bg-border sm:mt-20 sm:grid-cols-3 lg:grid-cols-4">
          {INTEGRATIONS.map((name) => (
            <div
              key={name}
              className="group flex items-center gap-3 bg-card p-6 transition-colors hover:bg-muted/40"
              data-testid={`integration-${name.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-border bg-muted/50 text-muted-foreground transition-colors group-hover:text-brand-teal">
                <Icon name="Plug" className="h-4 w-4" />
              </span>
              <span className="text-sm font-medium">{name}</span>
            </div>
          ))}
        </Reveal>
        <Reveal className="mt-6 text-center text-sm text-muted-foreground">
          Don't see your tool? It's on the roadmap — tell us what you need on the{" "}
          <a href="/contact" className="font-medium text-foreground underline-offset-4 hover:underline">contact page</a>.
        </Reveal>
      </div>
    </section>
  );
}
